import { Accordion } from '../components/Accordion';

const placeInfoArr = Array.from(document.querySelectorAll('.place__info'));
const placeInfoParams = {
  accordionActiveClass: 'place__info_active',
  accordionBodySelector: '.place__info-row',
  accordionTogglerSelector: '.place__info-header',
};

placeInfoArr.forEach((placeInfoArrEl) => {
  const placeInfoAccordion = new Accordion(placeInfoArrEl, placeInfoParams);
  placeInfoAccordion.setEventListeners();
});

const dropdownArr = Array.from(document.querySelectorAll('.dropdown'));
const dropdownParams = {
  accordionActiveClass: 'dropdown_active',
  accordionBodySelector: '.dropdown__inner',
  accordionTogglerSelector: '.dropdown__header',
};

dropdownArr.forEach((dropdownArrEl) => {
  const dropdownAccordion = new Accordion(dropdownArrEl, dropdownParams);
  dropdownAccordion.setEventListeners();
});

/* sidebar nav */
const sidebarNavCategoryArr = Array.from(document.querySelectorAll('.sidebar-nav__category'));
const sidebarNavParams = {
  accordionActiveClass: 'sidebar-nav__category_active',
  accordionBodySelector: '.accordion-body',
  accordionTogglerSelector: '.sidebar-nav__item',
};

sidebarNavCategoryArr.forEach((sidebarNavCategoryArrEl) => {
  const sidebarNavCategory = new Accordion(sidebarNavCategoryArrEl, sidebarNavParams);
  sidebarNavCategory.setEventListeners();
});

/* sidebar filter */
const filterSectionsArr = Array.from(document.querySelectorAll('.filter__section'));
const filterSectionParam = {
  accordionActiveClass: 'filter__section_active',
  accordionBodySelector: '.accordion-body',
  accordionTogglerSelector: '.filter__heading',
};

filterSectionsArr.forEach((filterSectionsArrEl) => {
  const filterSection = new Accordion(filterSectionsArrEl, filterSectionParam);
  filterSection.setEventListeners();
  filterSection.setSectionVisible();
});
